<template>
  <el-container class="body_container">
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">直播</el-row>
      <el-form v-model="searchVo" :inline="true" ref="search">
        <el-row type="flex">
          <el-col>
            <el-form-item prop="category" label="类型" label-width="40px"  size="small">
              <el-select v-model="searchVo.category" placeholder="请选择" style="width: 100px">
                <el-option label="标题" value="title"></el-option>
                <el-option label="讲师姓名" value="name"></el-option>
              </el-select>
              <el-input v-model="searchVo.title" placeholder="输入查询内容"  style="width: 160px">
                <el-button  @click="search" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="时间" label-width="40px"  size="small" style="margin-left: 15px">
              <el-date-picker
                style="width: 150px"
                v-model="searchVo.startTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期">
              </el-date-picker>
              <el-date-picker
                style="width: 150px"
                v-model="searchVo.endTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="dialog-footer" >
              <el-button type="primary" @click="search">查询</el-button>
              <el-button @click="resetForm('search')" style="background-color: #fff;border: 1px solid #3e64ff;color: #3e64ff;padding: 7px 12px">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <el-form-item class="dialog-footer">
              <el-button  @click="add('addLive')" type="primary">新建</el-button>
              <!--添加视频弹窗组件 -->
              <add-live ref="addBranch" v-if="addLiveVisible" :visible.sync="addLiveVisible" :values="liveId" @callFather="reload"></add-live>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-header>
    <el-main class="search_result">
      <el-table :data="lives.list">
        <el-table-column prop="title" label="标题" min-width="200px"></el-table-column>
        <!--<el-table-column prop="img" label="内容图片" min-width="120px">-->
          <!--<template   slot-scope="scope">-->
            <!--<img :src="url + scope.row.img"  min-width="70" height="70" />-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column prop="name" label="讲师姓名" min-width="100px"></el-table-column>
        <!--<el-table-column prop="photo" label="讲师照片" min-width="120px">-->
          <!--<template   slot-scope="scope">-->
            <!--<img :src="url + scope.row.photo"  min-width="70" height="70" />-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column prop="startTime" label="开始时间" min-width="150px"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" min-width="150px"></el-table-column>
        <el-table-column prop="liveStatus" :formatter="formatterColumn" label="直播状态" min-width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.liveStatus === '0'" style="color: red">已计划</span>
            <span v-if="scope.row.liveStatus === '1'" style="color: limegreen">已开始</span>
            <span v-if="scope.row.liveStatus === '2'" style="color: blue">已结束</span>
            <span v-if="scope.row.liveStatus === '3'" style="color: #ffb002">已取消</span>
            <span v-if="scope.row.liveStatus === '9'" style="color: gray">停播</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
            <i class="el-icon-edit" @click="checkLive(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
            <i class="el-icon-delete" @click="delLive(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            <!--</el-button>-->
            &nbsp;
            <el-link type="primary" :underline="false" v-if="scope.row.liveStatus !== '9'" @click="stop(scope.row)">停播</el-link>
            <el-link type="primary" :underline="false" v-else @click="resStart(scope.row)">恢复播放</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="lives.rows"
                   :current-page="lives.page"
                   layout="prev, pager, next, jumper"
                   :total="lives.total">
    </el-pagination>
  </el-container>
</template>

<script>
import Live from './live/Live.vue'
import video from '@/api/video'
import live from '@/api/live'
export default {
  name: 'Live',
  data () {
    return {
      liveId: null,
      url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/',
      addLiveVisible: false,
      lives: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      searchVo: {
        category: '',
        title: '',
        startTime: '',
        endTime: ''
      },
      value2: '1',
      type: 'H',
      page: 1,
      size: 10
    }
  },
  methods: {
    // 停播
    stop (row) {
      this.$confirm('确定停播吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        live.stop({id: row.id, stop: 1}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code === 0){
            this.reload()
          }
        })
      }).catch(() => {
      });
    },
    // 恢复播放
    resStart (row) {
      this.$confirm('确定恢复播放吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        live.stop({id: row.id, stop: 0}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code === 0){
            this.reload()
          }
        })
      }).catch(() => {
      });
    },
    checkLive (row) {
      this.liveId = row.id
      // console.log(this.liveId)
      this.addLiveVisible = true
    },
    delLive (row) {
      this.$confirm('确定删除该直播吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        live.del({id: row.id}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code === 0){
            this.reload()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page = val
      this.reload()
    },
    reload () {
      live.find({page: this.page, limit: this.size }).then(res => {
        this.lives = res.data.data
      })
    },
    formatterColumn (row, column) {
      return row.liveStatus === '0' ? '已计划' : row.liveStatus === '1' ? '已开始' : row.liveStatus === '2' ? '已结束' :row.liveStatus === '3' ? '已取消' :row.liveStatus === '9' ? '停播' : ''
    },
    add (refForm) {
      this.liveId = null
      if (this.$refs[refForm]) {
        this.$refs[refForm].initForm()
      }
      this.addLiveVisible = true
    },
    // userStatus (row, col) {
    //   if (row['userStatus'] === '1') {
    //     return this.options[1].label
    //   } else if (row['userStatus'] === '0') {
    //     return this.options[2].label
    //   }
    // },
    search () {
      this.page = 1
      let obj={}
      obj[this.searchVo.category]  = this.searchVo.title
      obj.page = this.page
      obj.limit = this.size
      obj.startTime = this.searchVo.startTime
      obj.endTime = this.searchVo.endTime
      live.find(obj).then(res => {
        this.lives = res.data.data
        // console.log(this.lives)
      })
    },
    // 重置form
    resetForm (formName) {
      this.searchVo.title = ''
      this.searchVo.startTime = ''
      this.searchVo.endTime = ''
      this.reload()
    },
    updateData (val) {
      this.page = val
      this.reload()
    }
  },
  components: {
    'add-live': Live
  },
  created () {
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/video/Live.vue